import React, { ReactElement } from 'react'
import {
  CopySvg,
  ArrowHeader,
  ArrowDynamic,
  LoaderSvg,
  CheckSvg,
  Pen,
  Thumb,
  Trash,
  MagicWand,
  Instruments,
  Purpose,
  Arrow,
  EmailSvg,
  ArrowUp,
  ArrowDown
} from '@src/static/svg'

export type Name =
  | 'copy'
  | 'arrow-header'
  | 'arrow-dynamic'
  | 'loader'
  | 'check'
  | 'pen'
  | 'thumb'
  | 'trash'
  | 'magicWand'
  | 'instruments'
  | 'purpose'
  | 'arrow'
  | 'email'
  | 'arrowUp'
  | 'arrowDown'

export function getSvg(name: Name): ReactElement {
  switch (name) {
    case 'copy':
      return <CopySvg />
    case 'arrow-header':
      return <ArrowHeader />
    case 'arrow-dynamic':
      return <ArrowDynamic />
    case 'loader':
      return <LoaderSvg />
    case 'check':
      return <CheckSvg />
    case 'pen':
      return <Pen />
    case 'thumb':
      return <Thumb />
    case 'trash':
      return <Trash />
    case 'magicWand':
      return <MagicWand />
    case 'instruments':
      return <Instruments />
    case 'purpose':
      return <Purpose />
    case 'arrow':
      return <Arrow />
    case 'email':
      return <EmailSvg />
    case 'arrowUp':
      return <ArrowUp />
    case 'arrowDown':
      return <ArrowDown />
    default:
      return <div>Not name svg</div>
  }
}
